export interface IRulingNumber {
	svg: {
		fillColor: string
		strokeColor: string
		strokeCover: string
	}
	number: number
}
export const rulingNumbers: IRulingNumber[] = [
	{
		svg: {
			fillColor: '#FFC947',
			strokeColor: '#001744',
			strokeCover: '#FF7D55',
		},
		number: 2
	},
	{
		svg: {
			fillColor: '#82DCFF',
			strokeColor: '#001744',
			strokeCover: '#337AFF',
		},
		number: 3
	},
	{
		svg: {
			fillColor: '#A2F6BE',
			strokeColor: '#001744',
			strokeCover: '#14A800',
		},
		number: 4
	},
	{
		svg: {
			fillColor: '#F85A5A',
			strokeColor: '#001744',
			strokeCover: '#ED1C24',
		},
		number: 5
	},
	{
		svg: {
			fillColor: '#337AFF',
			strokeColor: '#001744',
			strokeCover: '#005AFF',
		},
		number: 6
	},
	{
		svg: {
			fillColor: '#E2E2E2',
			strokeColor: '#001744',
			strokeCover: '#BDBDBD',
		},
		number: 7
	},
	{
		svg: {
			fillColor: '#FF7D55',
			strokeColor: '#001744',
			strokeCover: '#ED1C24',
		},
		number: 8
	},
	{
		svg: {
			fillColor: '#001744',
			strokeColor: '#337AFF',
			strokeCover: '#337AFF',
		},
		number: 9
	},
	{
		svg: {
			fillColor: '#8AEBFF',
			strokeColor: '#001744',
			strokeCover: '#337AFF',
		},
		number: 10
	},
	{
		svg: {
			fillColor: '#09A880',
			strokeColor: '#001744',
			strokeCover: '#A2F6BE',
		},
		number: 11
	},
	{
		svg: {
			fillColor: '#FAE18F',
			strokeColor: '#001744',
			strokeCover: '#FFC947',
		},
		number: 22
	}
]

export interface IBookNumerology {
	content: string | number
	image: string
	info: {
		title: string
		subTitle: string
	},
	link: string
}
const imgBaseUrl = `${process.env.IMAGE_BASE_URL}`
export const bookNumerology: IBookNumerology[] = [
	{
		content: 1,
		image: `${imgBaseUrl}/numerology/numerology-and-the-divine-triangle.png`,
		info: {
			title: "Numerology and the Divine Triangle",
			subTitle: "Faith Javane",
		},
		link: 'https://www.amazon.com/Numerology-Divine-Triangle-Faith-Javane/dp/0914918109'
	},
	{
		content: 2,
		image: `${imgBaseUrl}/numerology/the-complete-book-of-numerology.png`,
		info: {
			title: "Numerology and the Divine Triangle",
			subTitle: "David A.Phillips",
		},
		link: 'https://www.amazon.com/Complete-Book-Numerology-David-Phillips/dp/140190727X/ref=d_bmx_dp_844jrcln_sccl_2_2/130-7482161-3900126?pd_rd_w=T7RjF&content-id=amzn1.sym.44f42570-253d-4aa1-bbda-9874f36177cb&pf_rd_p=44f42570-253d-4aa1-bbda-9874f36177cb&pf_rd_r=CKMB00YSRE0RS0K1CD8D&pd_rd_wg=rjRxl&pd_rd_r=f67eeba7-7320-440b-8eea-b5e003c604e1&pd_rd_i=140190727X&psc=1'
	},
	{
		content: 3,
		image: `${imgBaseUrl}/numerology/numerology-the-key-to-your-inner-self.png`,
		info: {
			title: "Numerology and the Divine Triangle",
			subTitle: "Hans Decoz",
		},
		link: 'https://www.amazon.com/Numerology-Complete-Understanding-Numbers-Destiny/dp/039952732X/ref=d_pd_sbs_vft_none_sccl_1_1/130-7482161-3900126?pd_rd_w=lEY0y&content-id=amzn1.sym.3676f086-9496-4fd7-8490-77cf7f43f846&pf_rd_p=3676f086-9496-4fd7-8490-77cf7f43f846&pf_rd_r=X65G73S88SAHHYHGWHW2&pd_rd_wg=b8vMO&pd_rd_r=85be176c-ecd3-4f8e-bbd9-2de332cc8381&pd_rd_i=039952732X&psc=1'
	},
	{
		content: 4,
		image: `${imgBaseUrl}/numerology/thay-doi-cuoc-song-voi-nhan-so-hoc.png`,
		info: {
			title: "Numerology and the Divine Triangle",
			subTitle: "MayQ Inspiration Group",
		},
		link: 'https://tiki.vn/sach-thay-doi-cuoc-song-voi-nhan-so-hoc-le-do-quynh-huong-p71345381.html'
	}
]